import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import store from '../store'

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/todos",
        name: "Todos",
        component: () =>
            import("../views/Todos.vue")
    },

    {
        path: "/todos/:id",
        name: "Todo",
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/authenticated']) {
                return next({
                    name: 'Login'
                })
            }
        },
        component: () =>
            import("../views/Todo.vue")
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/Login.vue")
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/Register.vue")
    },
    {
        path: "/registration-confirmation",
        name: "RegistrationConfirmation",
        component: () => import("../views/RegistrationConfirmation.vue")
    },
    {
        path: "/about",
        name: "About",
        component: () => import("../views/About.vue")
    },
    {
        path: "/contact",
        name: "Contact",
        component: () => import("../views/Contact.vue")
    },
    {
        path: "/for_get_password",
        name: "ForGetPassword",
        component: () => import("../views/ForGetPassword.vue")
    },
    {
        path: "/reset_password",
        name: "ResetPassword",
        component: () => import("../views/ResetPassword.vue")
    },
    {
        path: "/new-todo",
        name: "NewTodo",
        component: () => import("../views/NewTodo.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    linkExactActiveClass: "bg-blue-700 ",
    base: process.env.BASE_URL,
    routes
});

export default router;
